<template>
  <th v-if="isHeader">
    <!--  -->
    Actions
  </th>
  <td v-else>
    <div>
      <dropdown v-if="$route.meta.isAdmin">
        <dropdown-action
          danger
          icon="back"
          @click="onClickView"
          v-if="!rowData.current_version && rowData.status !== 'rejected'"
        >View version</dropdown-action>
        <dropdown-action
          danger
          icon="back"
          @click="onClickReinstate"
          v-if="!rowData.current_version && rowData.status !== 'rejected'"
        >Re-instate version</dropdown-action>

        <!-- <dropdown-action icon="chart" @click="onClickDownloadInsights">Download Insights</dropdown-action> -->
        
      </dropdown>

      
    </div>
  </td>
</template>

<script>
import Dropdown from "./Dropdown";
import DropdownAction from "./DropdownAction";
import { Download } from "./../mixins/download";

import TrAction from "./TableRowAction";

import VuetableFieldMixin from "vuetable-2/src/components/VuetableFieldMixin";

export default {
  name: "document-actions",

  props: {
    rowData: Object
  },

  methods: {
    onClickCreateVersion() {
      if (this.rowData.policy_id) {
        this.$router.push({
          name: "AdminDocumentCreateVersion",
          params: { id: this.rowData.policy_id }
        });
      } else {
        this.$router.push({
          name: "AdminDocumentCreateVersion",
          params: { id: this.rowData.id }
        });
      }
    },

    onClickDownload() {
      const vm = this;
      const fileData = vm.rowData.current_version.file;
      this.$store.dispatch("files/download", fileData);
      this.showWarning();
    },

    onClickApprove() {
      if (this.rowData.policy_id) {
        console.log(this.rowData);
        this.$router.push({
          name: "AdminDocumentVersionApprove",
          params: { id: this.rowData.policy_id, versionId: this.rowData.id }
        });
      } else {
        this.$router.push({
          name: "AdminDocumentApprove",
          params: { id: this.rowData.id }
        });
      }
    },

    onClickView() {
      this.$router.push({
        name: "AdminFormVersionPreview",
        params: {
          id: this.rowData.eform_id,
          versionId: this.rowData.id
        }
      });
    },

    onClickReject() {
      if (this.rowData.policy_id) {
        this.$router.push({
          name: "AdminDocumentVersionReject",
          params: { id: this.rowData.policy_id, versionId: this.rowData.id }
        });
      } else {
        this.$router.push({
          name: "AdminDocumentReject",
          params: { id: this.rowData.id }
        });
      }
    },

    onClickDownloadInsights() {
      // TODO:
    },

    onClickPreview() {
      if (this.rowData.policy_id) {
        this.$router.push({
          name: "AdminDocumentVersionPreview",
          params: { id: this.rowData.policy_id, versionId: this.rowData.id }
        });
      } else {
        this.$router.push({
          name: "AdminDocumentPreview",
          params: { id: this.rowData.id }
        });
      }
    },

    onClickStar() {
      if (!this.rowData.user_favourite) {
        this.$store.dispatch("documents/favourite", this.rowData.id);
      } else {
        this.$store.dispatch("documents/unfavourite", this.rowData.id);
      }

      this.rowData.user_favourite = !this.rowData.user_favourite;
    },

    onClickDelete() {
      this.$store.dispatch("createDialog", {
        confirm: () => {
          this.$store.dispatch("documents/delete", this.rowData.id);
        }
      });
    },

    onClickReinstate() {
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("Forms/approveForm", {
              formId: this.rowData.eform_id,
              versionId: this.rowData.id
            })
            .then(resp => {
              this.$store.dispatch("Forms/list");
            });
        }
      });
    }
  },

  components: {
    Dropdown,
    DropdownAction,
    TrAction
  },

  mixins: [VuetableFieldMixin, Download]
};
</script>
